import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Modal, Row, Col, Form } from 'react-bootstrap';
import { CopyToClipboard } from 'react-copy-to-clipboard';

import { saveAccInfo, changePassword } from '../Auth/AuthActions';
import PasswordInput from '../../components/PasswordInput';
import copyIcon from '../../assets/images/copy-gray-icon.svg';
import SaveIcon from '../../assets/images/save.svg';
import AddImages from '../../assets/images/add-flat-icon.svg';
import Close from '../../assets/images/close.svg';

import './Account.scss';

class AccountModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpened: false,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.user !== this.props.user && this.state.isOpened) {
      this.updateUserState();
    }
  }

  updateUserState() {
    this.setState({
      name: this.props.user.name,
      email: this.props.user.email,
      company: this.props.user.partner ? this.props.user.partner.name : '',
      photoUrl: this.props.user.photo,
      copied: false,
      courseCopied: false,
    });
  }

  onButtonClick = () => {
    this.setState({ isOpened: true }, () => this.updateUserState());
  };

  onClose = (event) => {
    if (event) {
      event.stopPropagation();
    }
    this.setState({ isOpened: false });
  };

  triggerInputFile = () => {
    this.fileInput.click();
  };

  handleFileUpload = (ev) => {
    this.setState({
      photoUrl: ev.target.files.length ? URL.createObjectURL(ev.target.files[0]) : undefined,
      photo: ev.target.files.length ? ev.target.files[0] : undefined,
    });
  };

  handleChange = (ev) => {
    this.setState({ [ev.target.name]: ev.target.value });
  };

  saveAccInfo = () => {
    this.props
      .saveAccInfo({
        name: this.state.name,
        email: this.state.email,
        company: this.state.company,
        photo: this.state.photo,
      })
      .then(() => {});
  };

  sendResetPassword = () => {
    this.props
      .changePassword({
        newPassword: this.state.newPassword,
        oldPassword: this.state.oldPassword,
      })
      .then(() => {
        this.setState({ oldPassword: '', newPassword: '' });
      });
  };

  render() {
    const { user } = this.props;

    const referralUrl = user && user.partner
      ? `https://getnave.com/kanban-dashboards${user.partner.refId ? `?referral=${user.partner.refId}` : ''}`
      : '';
    const courseUrl = user && user.partner
      ? `https://getnave.com/enroll${user.partner.refId ? `?referral=${user.partner.refId}` : ''}`
      : '';

    const modal = (
      <Modal show={this.state.isOpened} onHide={this.onClose} className='account_modal' size='lg'>
        <Modal.Header>
          <Modal.Title>My Account</Modal.Title>
          <Button variant="close" onClick={this.onClose}>
            <img src={Close} alt="close" />
          </Button>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col xs={12} md={8}>
              <Form.Group className='account_modal__field'>
                <Form.Label>Name</Form.Label>
                <Form.Control
                  name="name"
                  type="text"
                  id="acc_modal_name"
                  placeholder="Name"
                  value={this.state.name || ''}
                  onChange={this.handleChange}
                />
              </Form.Group>

              <Form.Group className='account_modal__field'>
                <Form.Label>Email</Form.Label>
                <Form.Control
                  name="email"
                  type="email"
                  id="acc_modal_email"
                  placeholder="Email"
                  value={this.state.email || ''}
                  onChange={this.handleChange}
                />
              </Form.Group>

              <Form.Group className='account_modal__field'>
                <Form.Label>Company Name</Form.Label>
                <Form.Control
                  name="company"
                  type="text"
                  id="acc_modal_company"
                  placeholder="Company Name"
                  value={this.state.company || ''}
                  onChange={this.handleChange}
                />
              </Form.Group>

              {user && user.partner && (
                <Form.Group className='account_modal__field'>
                  <Form.Label>Referral Link</Form.Label>
                  <div className='account_modal__input-copy'>
                    <Form.Control
                      disabled
                      name="loginUrl"
                      type="text"
                      id="acc_modal_loginUrl"
                      value={referralUrl}
                    />
                    <CopyToClipboard text={referralUrl} onCopy={() => this.setState({ copied: true })}>
                      <Button variant="flat" className='btn-copy' title={this.state.copied ? 'Copied!' : 'Copy'}>
                        <img src={copyIcon} alt="copy" />
                      </Button>
                    </CopyToClipboard>
                  </div>
                </Form.Group>
              )}

              {user && user.partner && (
                <Form.Group className='account_modal__field'>
                  <Form.Label>Digital Course Link</Form.Label>
                  <div className='account_modal__input-copy'>
                    <Form.Control
                      disabled
                      name="courseUrl"
                      type="text"
                      id="acc_modal_courseUrl"
                      value={courseUrl}
                    />
                    <CopyToClipboard text={courseUrl} onCopy={() => this.setState({ courseCopied: true })}>
                      <Button variant="flat" className='btn-copy' title={this.state.courseCopied ? 'Copied!' : 'Copy'}>
                        <img src={copyIcon} alt="copy" />
                      </Button>
                    </CopyToClipboard>
                  </div>
                </Form.Group>
              )}
            </Col>
            <Col xs={12} md={4}>
              <div className='account_modal__avatar' onClick={this.triggerInputFile}>
                <input
                  style={{ display: 'none' }}
                  type="file"
                  accept="image/*"
                  ref={(fileInput) => (this.fileInput = fileInput)}
                  onChange={this.handleFileUpload}
                />
                <div className={`images ${this.state.photoUrl ? ' images--uploaded' : ''}`}>
                  <img alt="profile" src={this.state.photoUrl || AddImages} />
                </div>
                <span className='label_upload_photo'>Upload photo</span>
              </div>
            </Col>
          </Row>

          <hr />

          <div className='account_modal__reset-row'>
            <Form.Group className='account_modal__field'>
              <PasswordInput
                autoComplete="new-password"
                name="oldPassword"
                id="acc_modal_oldPassword"
                value={this.state.oldPassword || ''}
                onChange={this.handleChange}
                label="Old Password"
              />
            </Form.Group>
          
            <Form.Group className='account_modal__field'>
              <PasswordInput
                autoComplete="new-password"
                name="newPassword"
                id="acc_modal_newPassword"
                value={this.state.newPassword || ''}
                onChange={this.handleChange}
                label="New Password"
              />
            </Form.Group>
          
            <Button variant="secondary" size="md" onClick={this.sendResetPassword}>
              Reset Password
            </Button>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={this.saveAccInfo}>
            <img src={SaveIcon} alt="#" />
            Save Changes
          </Button>
          <Button variant="secondary" onClick={this.onClose}>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    );

    if (this.props.children) {
      const btn = React.Children.only(this.props.children);
      return React.cloneElement(btn, { onClick: this.onButtonClick }, btn.props.children, modal);
    }

    return (
      <Button onClick={this.onButtonClick}>
        Account
        {modal}
      </Button>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  saveAccInfo: (model) => dispatch(saveAccInfo(model)),
  changePassword: (model) => dispatch(changePassword(model)),
});

function mapStateToProps(state) {
  return { user: state.auth.user };
}

export default connect(mapStateToProps, mapDispatchToProps)(AccountModal);
